// extracted by css-extract-rspack-plugin
export default {"dot":"_2f1eee24","activeDot":"_42b039a8"};